import React, { useMemo, useState } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Frame } from '@shopify/polaris';
import { useDispatch, useSelector } from 'react-redux';
import { generateToken } from './redux/slice/commonSlice';
import { getUserOnboardingAsync } from './redux/userOnboarding';
import { getAllUserOnboarding } from './redux/userOnboarding/slice';
import { Router, routes } from './router/Router';
import LoadingComponent from './components/common/Loading';
import '@shopify/polaris/build/esm/styles.css';

function App() {
  const dispatch = useDispatch();
  const { status } = useSelector((store) => store.commonData);
  const { userOnboardingData } = useSelector(getAllUserOnboarding);
  const [isLoading, setIsLoading] = useState(false);

  useMemo(async () => {
    setIsLoading(true);
    await dispatch(generateToken()).unwrap();
    await dispatch(getUserOnboardingAsync()).unwrap();
    setIsLoading(false);
  }, []);

  if (isLoading || !status) {
    return <LoadingComponent />;
  };

  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<Router />} >
            {routes.slice(userOnboardingData?.is_onboarding ? 1 : 0, routes.length).map((route, i) => (<Route exact={true} path={route.path} key={i} element={
              <Frame>
                {route.component}
              </Frame>} />))}
            <Route element={<Navigate to='/' replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
